import { Box, type BoxProps } from '@mui/material';

import type { FC } from 'react';

export interface GoogleMapIframeProps extends BoxProps {
  src: string;
}

export const GoogleMapIframe: FC<GoogleMapIframeProps> = ( { src, ...props } ) => (
  <Box
    component={'iframe'}
    borderRadius={2}
    minHeight={400}
    width="100%"
    height="100%"
    title="map"
    scrolling="no"
    src={src}
    style={{ border: 0 }}
    allowFullScreen={true}
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    {...props}
  />
);
